import { NgClass } from '@angular/common';
import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { UserGridItemObject } from '@it2go/types';
import { contractVisibility } from '../shared/helpers';
import { FormatPersonPipe } from '../../../../shared/pipes/format-person.pipe';

@Component({
    selector: 'app-user-main-info',
    templateUrl: './user-main-info.component.html',
    styleUrls: ['./user-main-info.component.scss'],
    imports: [
        FormatPersonPipe,
        NgClass,
        TranslatePipe,
    ],
})
export class UserMainInfoComponent implements OnChanges {
    @Input() user: UserGridItemObject | null = null;
    protected employments: { name: string, size: string }[] = [];

    get isActive(): boolean {
        return this.user?.active ?? false;
    }

    public ngOnChanges(changes: SimpleChanges): void {
        if (changes['user']) {
            this.user?.employments?.forEach((employment) => {
                const { workloadVisible, scopeOfWorkVisible } = contractVisibility(employment.contract);
                let size = '';
                if (workloadVisible) {
                    size = employment.workloadSize?.toString() ?? '';
                }
                if (scopeOfWorkVisible) {
                    size = employment.scopeOfWork ? employment.scopeOfWork.toString() + 'h' : '';
                }
                this.employments.push({
                    name: employment.employmentTypeName ? 'user.common.employmentTypes.' + employment.employmentTypeName : '',
                    size: size ? `(${size})` : '',
                });
            });
        }
    }
}
